import { useCallback } from 'react';
import { mapEventForProviders } from '../core/mapper';
import { googleProvider } from '../providers/google';
import { facebookProvider } from '../providers/facebook';
import { tiktokProvider } from '../providers/tiktok';
import { internalProvider } from '../providers/internal';

const providers = {
  google: googleProvider,
  facebook: facebookProvider,
  tiktok: tiktokProvider,
  internal: internalProvider,
};

export const useTracking = () => {
  const track = useCallback((eventKey, payload = {}) => {
    const mapped = mapEventForProviders(eventKey, payload);

    Object.keys(providers).forEach((providerKey) => {
      const provider = providers[providerKey];
      const target = mapped[providerKey];
      if (!target?.eventName) return;
      try {
        provider.track(target.eventName, target.payload, target.options);
      } catch (error) {}
    });
  }, []);

  return { track };
};
